import { call, put, select } from 'redux-saga/effects'
import { callApi } from '@/shared/tools/apiSagaHelper'
import { selectExtraRoutesAuthData } from '@/containers/Login/AuthSelectors'
import { selectCurrentContractActive } from '../SubscriptionFormSelectors'
import { updateContractDefaultData } from '../SubscriptionFormSlice'
import * as Sentry from '@sentry/react'

export const contractToolsActions = {
  EXPORT_LOGS_V2: 'EXPORT_LOGS_V2',
  HISTORIC_LOGS_V2: 'HISTORIC_LOGS_V2',
  LOAD_USERS_V2: 'LOAD_USERS_V2',
  PROCESS_CHANGE_USER_V2: 'PROCESS_CHANGE_USER_V2',
  RETRACT_CONTRACT_V2: 'RETRACT_CONTRACT_V2',
  ADD_COMMENT_TO_CONTACT_V2: 'ADD_COMMENT_TO_CONTACT_V2',
}

export function* fetchHistoricLogs({ callback, contactId, contractId = '' }) {
  const { historicLogsUrl } = yield select(selectExtraRoutesAuthData)
  const finalUrl = historicLogsUrl?.replace('*', contactId)?.replace('+', contractId)

  if (!finalUrl) {
    if (typeof callback === 'function') {
      yield call(callback, [], 500)
    }
    return
  }

  try {
    const result = yield call(callApi, {
      endpoint: finalUrl + '?version=v2',
      method: 'GET',
    })
    if (typeof callback === 'function') {
      yield call(callback, result, 200)
    }
  } catch (error) {
    const status = error?.status || 'unknown'
    if (import.meta.env.PROD && status !== 422) {
      Sentry.captureException(error, { extra: { context: 'fetchHistoricLogsSaga' } })
    }
    if (typeof callback === 'function') {
      yield call(callback, null, 500)
    }
  }
}

export function* fetchExportLogs({ callback, contactId }) {
  const { exportLogsUrl } = yield select(selectExtraRoutesAuthData)
  const finalUrl = exportLogsUrl?.replace('*', contactId)

  if (!finalUrl) {
    if (typeof callback === 'function') {
      yield call(callback, [], 500)
    }
    return
  }

  try {
    const result = yield call(callApi, {
      endpoint: finalUrl,
      method: 'GET',
    })
    if (typeof callback === 'function') {
      yield call(callback, result, 200)
    }
  } catch (error) {
    const status = error?.status || 'unknown'
    if (import.meta.env.PROD && status !== 422) {
      Sentry.captureException(error, { extra: { context: 'fetchExportLogsSaga' } })
    }
    if (typeof callback === 'function') {
      yield call(callback, null, 500)
    }
  }
}

export function* fetchUsersList({ callback }) {
  const { getUsersListUrl } = yield select(selectExtraRoutesAuthData)
  const { createdByOrganisationId = null } = yield select(selectCurrentContractActive) || {}
  const finalUrl = getUsersListUrl?.replace('*', createdByOrganisationId || '')

  if (!finalUrl || !createdByOrganisationId) {
    if (typeof callback === 'function') {
      yield call(callback, [], 500)
    }
    return
  }

  try {
    const result = yield call(callApi, {
      endpoint: finalUrl,
      method: 'GET',
    })
    if (typeof callback === 'function') {
      yield call(callback, result, 200)
    }
  } catch (error) {
    const status = error?.status || 'unknown'
    if (import.meta.env.PROD && status !== 422) {
      Sentry.captureException(error, { extra: { context: 'fetchUsersListSaga' } })
    }
    if (typeof callback === 'function') {
      yield call(callback, null, 500)
    }
  }
}

export function* processChangeUser({ contractId, userId, callback }) {
  const { contractOwnerChangeUrl } = yield select(selectExtraRoutesAuthData)
  const finalUrl = contractOwnerChangeUrl?.replace('*', contractId || '')

  if (!finalUrl || !contractId) {
    return
  }

  try {
    const result = yield call(callApi, {
      endpoint: finalUrl,
      method: 'POST',
      payload: { userId },
    })
    yield put(updateContractDefaultData({ createdById: userId }))
    if (typeof callback === 'function') {
      yield call(callback, result, 200)
    }
  } catch (error) {
    const status = error?.status || 'unknown'
    if (import.meta.env.PROD && status !== 422) {
      Sentry.captureException(error, { extra: { context: 'processChangeUserSaga' } })
    }
  }
}

export function* retractContract({ reason, id, callback }) {
  const { retractContractUrl } = yield select(selectExtraRoutesAuthData)
  const finalUrl = retractContractUrl?.replace('*', id || '')
  try {
    const result = yield call(callApi, {
      endpoint: finalUrl,
      method: 'POST',
      payload: { reason },
    })
    if (typeof callback === 'function') {
      yield call(callback, result, 200)
    }
  } catch (error) {
    const status = error?.status || 'unknown'
    if (import.meta.env.PROD && status !== 422) {
      Sentry.captureException(error, { extra: { context: 'retractContractSaga' } })
    }
    if (typeof callback === 'function') {
      yield call(callback, error, 500)
    }
  }
}

export function* addCommentToContact({ contactId, comment, callback }) {
  const { addCommentUrl } = yield select(selectExtraRoutesAuthData)
  try {
    const result = yield call(callApi, {
      endpoint: addCommentUrl,
      method: 'POST',
      payload: { comment, contact_id: contactId },
    })
    if (typeof callback === 'function') {
      yield call(callback, result, 200)
    }
  } catch (error) {
    const status = error?.status || 'unknown'
    if (import.meta.env.PROD && status !== 422) {
      Sentry.captureException(error, { extra: { context: 'addCommentToContactSaga' } })
    }
    if (typeof callback === 'function') {
      yield call(callback, error, 500)
    }
  }
}
